// import { useState } from "react";

import "./styles/LimitedEditionsInfo.css";
// import QuestionsIcon from "@/shared-components/icons/components/public/QuestionsIcon";

export default function LimitedEditionsInfo() {
  // const [openLimitedEditionsInfo, setOpenLimitedEditionsInfo] = useState(false);
  const openLimitedEditionsInfo = true;

  return (
    <>
      <div
        className="purchase-limited-editions-info__container element-non-selectable"
        // onClick={() => setOpenLimitedEditionsInfo(!openLimitedEditionsInfo)}
      >
        <span
          className="purchase-limited-editions-info__heading font-size-medium"
          style={{ marginBottom: "0px" }}
        >
          Limited Edition Details
        </span>

        {/* <QuestionsIcon
          className={`purchase-limited-editions-info__icon ${
            openLimitedEditionsInfo ? "active" : ""
          }`}
        /> */}
      </div>

      <div
        className={`purchase-limited-editions-info__accordeon ${
          openLimitedEditionsInfo ? "active" : ""
        }`}
      >
        {/* <span className="purchase-limited-editions-info__heading font-size-medium">
                    Details
        </span> */}

        <ul className="purchase-limited-editions-info__ul">
          <li className="purchase-limited-edition-info__li font-size-medium">
            ● Production and distribution are exclusive to Suarte
          </li>

          <li className="purchase-limited-edition-info__li font-size-medium">
            ● Museum quality: cotton canvas and vibrant inks
          </li>

          <li className="purchase-limited-edition-info__li font-size-medium">
            ● Suarte’s certificate of authenticity is included
          </li>

          <li className="purchase-limited-edition-info__li font-size-medium">
            ● Directly supports the Artist and the Gallery
          </li>

          <li className="purchase-limited-edition-info__li font-size-medium">
            ● Eco-friendly packaging
          </li>
        </ul>
      </div>
    </>
  );
}
